import React from 'react';
import { PropTypes } from 'prop-types';
import { compose, pure } from 'recompose';
import { Button } from '@ontruck/orc';

const enhance = compose(pure);

const ZipCodeQuoteItem = ({ zipcode, onClick, activeRef, t, className }) => (
  <div className={`${className} secondary`} ref={activeRef}>
    <Button
      type="button"
      onClick={onClick}
      className={className}
      ref={activeRef}
    >
      {t('get_zipcode_quote', { zipcode })}
    </Button>
  </div>
);

ZipCodeQuoteItem.propTypes = {
  zipcode: PropTypes.string,
  activeRef: PropTypes.func,
  className: PropTypes.string,
  onClick: PropTypes.func,
  t: PropTypes.func,
};

ZipCodeQuoteItem.defaultProps = {
  zipcode: '',
  className: '',
  activeRef: () => {},
  onClick: () => {},
  t: (t) => t,
};

export default enhance(ZipCodeQuoteItem);
